module.exports = __webpack_public_path__ + "img/sv76on.a3ca49b0.svg";